import { LoadState } from "../../../constants/enums";
import { getUniqueId } from "../../../helpers";

export interface ILifeInsuranceRidersState {
  data: ILifeInsuranceRiders;
  loading: LoadState;
  error: string | null;
}

export interface ILifeInsuranceRiders {
  customer_policy_id: number | null;
  riders: IRiderRow[];
  status: string | null;
}

export interface IRiderRow {
  key: string;
  incremental_number: number;
  rider: string | null;
  limit: string | null;
}

export const defaultLifeInsuranceRidersState: ILifeInsuranceRidersState = {
  data: {
    customer_policy_id: null,
    riders: [
      {
        key: getUniqueId(),
        incremental_number: 1,
        rider: null,
        limit: null,
      },
    ],
    status: "ACTIVE",
  },
  loading: LoadState.NotLoaded,
  error: null,
};
